/**
 * @ngdoc controllers
 * @memberof mercury.modules.cogs
 * @name ReportsCogsPurchasesCtrl
 * @description A report with sales grouped by Item Category and report interval
 */
angular.module('mercury.modules.reports.cogs')
.controller('ReportsCogsPurchasesCtrl', ["title", "reporttime", "ReportCogs", "ReportPosItems", "ReportsCogsPurchasesService", "$scope", "$q", function(title, reporttime, ReportCogs, ReportPosItems, ReportsCogsPurchasesService, $scope, $q) {
  title.set('Purchases');
  reporttime.setAllowedTypes(['week', 'month']);

  var allResults = [];
  $scope.reportResults = [];
  $scope.categories = [
    {values: [], key: 'All'}
  ];
  $scope.selectedCategoryIds = $scope.categories[0].values;

  $scope.cogsGraphColumns = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Stock Percentage', type: 'number', key: 'stockPerc', filter: 'percent'}
  ];
  $scope.cogsGraphOptions = {
    vAxis: {
      format: '#\'%\''
    }
  };

  $scope.loading = $q.all({
    purchasesSummary: ReportCogs.getPurchasesSummary(reporttime.start(), reporttime.end(), reporttime.interval()),
    categories: ReportPosItems.itemCategories()
  });

  $scope.loading.then(function(result) {
    allResults = result.purchasesSummary;

    result.categories.forEach(function(cat) {
      $scope.categories.push(cat);
    });

    $scope.setCategory();
  });

  $scope.setCategory = function() {
    $scope.reportResults = ReportsCogsPurchasesService.parseResults(allResults, $scope.selectedCategoryIds);
  };
}]);
